import React, { useState } from "react";
import { Box, Grid, Button, Typography, Container } from "@mui/material";
import ExpWithPicLeft from "../../ExpWithPicLeft";
import ExpWithPicRight from "../../ExpWithPicRight";

import ScienceTwoToneIcon from "@mui/icons-material/ScienceTwoTone";
import SanitizerTwoToneIcon from "@mui/icons-material/SanitizerTwoTone";
import CleanHandsTwoToneIcon from "@mui/icons-material/CleanHandsTwoTone";
import { makeStyles } from "@mui/styles";
import ContentCopyTwoToneIcon from "@mui/icons-material/ContentCopyTwoTone";
import HealthAndSafetyTwoToneIcon from "@mui/icons-material/HealthAndSafetyTwoTone";
import CardComp from "../Card";
import WbIridescentTwoToneIcon from "@mui/icons-material/WbIridescentTwoTone";
import ErrorIcon from "@mui/icons-material/Error";
import { SRLWrapper } from "simple-react-lightbox";
import Reveal from "react-reveal/Reveal";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import AddTaskIcon from "@mui/icons-material/AddTask";

import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTranslation } from "react-i18next";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  title: {
    fontSize: "30px",
    paddingTop: 20,
    paddingBottom: 100,
    textAlign: "center",
    lineHeight: "1.6em",
    // fontWeight: "bold",
  },
  icons: {
    maxWidth: "750px",
    display: "flex",
    justifyContent: "space-between",
    paddingTop: "50px",
    paddingBottom: "50px",
  },
  iconboxwrapper: {
    // border: "1px solid black",
    justifyContent: "center",
    alignItems: "center",
  },
  iconbox: {
    padding: "10px",
    borderRadius: "50%",
    // border: "3px solid #f5f5f5",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "150px",
    height: "150px",
    marginLeft: "auto",
    marginRight: "auto",
  },
}));

const Wipe1 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const { t, i18n } = useTranslation();
  const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
  return (
    <Grid
      container
      className={classes.root}
      sx={{
        width: { md: 3 / 4, sm: 1, xs: 1 },

        boxSizing: "content-box",
        marginLeft: "auto",
        marginRight: "auto",
      }}
    >
      <Box sx={{}}>
        <Reveal bottom>
          <Box>
            <Box
              className="textTitle"
              sx={{
                pb: 2,
                pt: 10,
                textAlign: { md: "left", sm: "center", xs: "center" },
              }}
            >
              It is an Advanced Technology
            </Box>
            <Box
              sx={{
                fontSize: "20px",
                lineHeight: "1.5em",
                fontWeight: 400,
                pt: 2,
                textAlign: { md: "left", sm: "center", xs: "center" },
              }}
            >
              With our Materials Technology (Anti-Bacterial, Incombustible,
              etc.),
              <br /> We make differences.
            </Box>
          </Box>
        </Reveal>
        <Box>
          <Grid
            container
            sx={{
              display: "flex",
              pt: 5,
              pb: 20,
              justifyContent: {
                md: "space-between",
                sm: "center",
                xs: "center",
              },
            }}
          >
            <Grid item md={4} sx={{ pt: 2 }}>
              <CardComp
                icon={<ScienceTwoToneIcon sx={{ fontSize: "32px" }} />}
                title="100% Non-Alchohol Sanitizing"
                content="Our wipes are powerful enough to cleanse every surfaces."
                link=""
                image="/img/CK_trd032tg06637.jpg"
                content2="We extract cleansing ingredients from natural tangerlines."
              />
            </Grid>
            <Grid item md={4} sx={{ pt: 2 }}>
              <CardComp
                icon={<CleanHandsTwoToneIcon sx={{ fontSize: "32px" }} />}
                title="99.9% Strong Sanitizing"
                content="Our wipes are powerful enough to cleanse every surfaces."
                link=""
                image="/img/CK_tip014d20040071.jpg"
                content2="Only with one sheet of our wipe, kill 99.9% harmful bacteria and viruses."
              />
            </Grid>
            <Grid item md={4} sx={{ pt: 2 }}>
              <CardComp
                icon={<SanitizerTwoToneIcon sx={{ fontSize: "32px" }} />}
                title="99.9% Sanitizing for 7 days"
                content="Our wipes are powerful enough to cleanse every surfaces."
                link=""
                image="/img/CK_ti219a20203.jpg"
                content2="Sanitizing will not be disappear for 168 hours."
              />
            </Grid>
            <Grid item md={4} sx={{ pt: 2 }}>
              <CardComp
                icon={<ContentCopyTwoToneIcon sx={{ fontSize: "32px" }} />}
                title="100% Biogradable Rayon"
                content="Our wipes are powerful enough to cleanse every surfaces."
                link=""
                image="/img/CK_trd022tg31669.jpg"
                content2="Our wipes are made with Non-woven and biogradable fabric."
              />
            </Grid>
            <Grid item md={4} sx={{ pt: 2 }}>
              <CardComp
                icon={<WbIridescentTwoToneIcon sx={{ fontSize: "32px" }} />}
                title="Natural Scents"
                content="We made our wipes without any artificial scent for your health."
                link=""
                image="/img/CK_tc01090000083.jpg"
                content2="We put 100% natural genuine phytoncide from trees."
              />
            </Grid>
            <Grid item md={4} sx={{ pt: 2 }}>
              <CardComp
                icon={<HealthAndSafetyTwoToneIcon sx={{ fontSize: "32px" }} />}
                title="Safe for your skin"
                content="Our wipes are made with all natural ingredients. It is safe for your skin."
                link=""
                image="/img/CK_ti436a12007.jpg"
                content2="Gold Colloid for skin health and moisturization."
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
      <Box sx={{ width: 1, pb: 10 }}>
        <Reveal bottom>
          <Box sx={{ fontSize: "20px" }}>Why Non-Alcohol?</Box>
          <Box sx={{ pt: 2 }}>
            - <span className="pink_link">Bad Effects</span> of Alcohol on
            Respiratory System and Skin
          </Box>
          <Box sx={{ mt: 5, backgroundColor: "lightgray", p: 3 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                width: 1,
              }}
            >
              <ErrorIcon
                sx={{
                  fontSize: "32px",
                  color: "#f3756d",
                }}
              />
            </Box>
            <br />
            <span style={{ textDecoration: "underline" }}>Alcohol</span>,&nbsp;
            <span style={{ textDecoration: "underline" }}>
              Isopropanol
            </span>{" "}
            and&nbsp;
            <span style={{ textDecoration: "underline" }}>
              Benzalkonium
            </span>{" "}
            must be carefully used for babies with low immune system, pregnant
            women, the elderly, and women with sensitive skin.
          </Box>
          <Grid container sx={{ pt: 5, display: "flex" }}>
            <Grid item md={6} sx={12} xs={12}>
              <img
                style={{ width: "90%", height: "auto" }}
                alt="baby"
                src="https://images.unsplash.com/photo-1476703993599-0035a21b17a9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80"
              />
            </Grid>
            <Grid item md={6} sx={12} xs={12}>
              <Box sx={{ pt: 4 }}>
                Alcohol makes our skin dry. Alcohol absolves through skin. And
                it drops the temperature of your skin.
              </Box>
              <Box sx={{ pt: 4 }}>WE DON’T USE HARMFUL CHEMICALS AT ALL.</Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  fontSize: "23px",
                  pt: 5,
                  justifyContent: "center",
                  lineHeight: "1.6em",
                }}
              >
                <Box>
                  <AddTaskIcon sx={{ color: "gray", pr: 1 }} />
                  No Alcohol
                </Box>
                <Box>
                  <AddTaskIcon sx={{ color: "gray", pr: 1 }} />
                  No Isopropanol
                </Box>
                <Box>
                  <AddTaskIcon sx={{ color: "gray", pr: 1 }} />
                  No Benzalkonium
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Reveal>
      </Box>
      {/* https://images.unsplash.com/photo-1526634332515-d56c5fd16991?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1770&q=80 */}

      <Box sx={{ width: 1, py: 10 }}>
        <Reveal bottom>
          <Box sx={{ fontSize: "20px" }}>
            7 Days of Long-Lasting Anti-Bacterial Protection
          </Box>
          <Box
            sx={{
              pt: 5,
              display: "flex",
              flexDirection: { md: "row", sm: "row", xs: "column" },
              alignItems: "center",
              justifyContent: "space-around",
              width: 1,
            }}
          >
            <Box
              sx={{
                textAlign: "center",
              }}
            >
              <Box>Other Brands (Alcohol)</Box>
              <img src="/img/alcohol_img1.png" alt="" width="400" />
              <Box sx={{ px: 6, pt: 2, minHeight: "100px" }}>
                After wiping the surface,{" "}
                <span className="pink_link">alcohol</span> is volatilized within
                a minute and soon it turns into an ideal condition for bacteria
                to grow and multiply.
              </Box>
            </Box>
            <Box
              sx={{ px: 2, display: { md: "block", sm: "none", xs: "none" } }}
            >
              VS.
            </Box>
            <Box sx={{ textAlign: "center" }}>
              <Box>HESLET (Silver Nano Technology)</Box>
              <img src="/img/alcohol_img2.png" alt="" width="400" />
              <Box sx={{ px: 6, pt: 2, minHeight: "100px" }}>
                Once wiped, tens of billions of{" "}
                <span className="pink_link">
                  anionic antibacterial coatings
                </span>
                &nbsp;are formed and 99.9% anti-bacterial function persists for
                7 days.
              </Box>
            </Box>
          </Box>
        </Reveal>
      </Box>
      <Box
        sx={{
          backgroundColor: "#f2f2f2",
          width: 1,
          py: 10,
          textAlign: "center",
          fontSize: "22px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          px: { md: 7, sm: 2 },
        }}
      >
        <Typography sx={{ pb: 1 }}>
          24 billion per&nbsp;
          <var>
            1cm<sup>2</sup>
          </var>
        </Typography>
        Strong Cleansing Power <br />
        <br />
        <section id="silver-colloid"></section>
        <Box sx={{ pt: 1, pb: 3, fontSize: "33px", fontWeight: "600" }}>
          Silver Colloid
        </Box>
        <Box
          sx={{
            backgroundColor: "white",
            minWidth: "200px",
            maxWidth: 800,
            border: "1px solid lightgray",
            p: 5,
            borderRadius: "20px",
            mt: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box sx={{ width: 1, fontSize: "15px", lineHeight: "1.8em" }}>
            <Box sx={{ mb: 2, fontSize: "23px" }}>WHAT IS SILVER COLLOID?</Box>
            Silver colloids, known as natural antibiotics, have 650 different
            bacteria. It sterilizes various fungi and has antibacterial power
            against viruses. It also prevents germs from becoming resistant to
            this and is harmless to the human body.
            <Box sx={{ pt: 2, borderTop: "1px solid lightgray", my: 4 }}></Box>
            <Box sx={{ mb: 2, fontSize: "23px" }}>HOW IS IT MADE?</Box>
            After making silver with high purity (99.9%) into very small
            ultrafine particles, Dissolve in pure purified water to form a
            solution. Silver ions prevent the activation of bacteria and
            eliminate it by damaging the bacterial membrane.
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          width: 1,
          pt: 10,
        }}
      >
        <Reveal bottom>
          <Grid item md={12} sm={12}>
            <Box sx={{ fontSize: "20px" }}>Why Magic-Clean?</Box>
            <Box sx={{ pt: 2 }}>
              - All purpose wipe is tough enough to fight with almost any mess.
              See the differences.
            </Box>
          </Grid>
          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: { md: "row", sm: "column" },
              justifyContent: "center",
              alignItems: "center",
              pt: 4,
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              Before
              <img
                src="/img/before1.jpg"
                alt="before"
                style={{ width: "380px" }}
              />
            </Box>
            <Box
              sx={{
                pl: { md: 5 },
                pt: { md: 0, sm: 5 },
                display: "flex",
                flexDirection: "column",
              }}
            >
              After
              <img
                src="/img/after1.jpg"
                alt="after"
                style={{ width: "380px" }}
              />
            </Box>
          </Grid>

          <Grid
            item
            sx={{
              display: "flex",
              flexDirection: { md: "row", sm: "column" },
              justifyContent: "center",
              alignItems: "center",
              pt: 4,
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              Before
              <img
                src="/img/before2.jpg"
                alt="before"
                style={{ width: "380px" }}
              />
            </Box>
            <Box
              sx={{
                pl: { md: 5 },
                pt: { md: 0, sm: 5 },
                display: "flex",
                flexDirection: "column",
              }}
            >
              After
              <img
                src="/img/after2.jpg"
                alt="after"
                style={{ width: "380px" }}
              />
            </Box>
          </Grid>
        </Reveal>
      </Box>

      <Box sx={{ pt: 10 }}>
        <ExpWithPicRight
          imgHeight="300"
          smallTitle="Let's save our earth"
          title="Other brand wipes uses PLASTIC - Normal disposable wipes fabric"
          imgUrl="https://images.unsplash.com/photo-1606037150583-fb842a55bae7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1674&q=80"
          content="- Plastic fabric decomposing takes 100 YEARS the life cycle of plastics.<br /><br />- Environmental pollution toxic Chemicals releases (e.g., Dioxin)<br /><br />- Threats to Marine Biodiversity "
        />
      </Box>

      <section id="rayon"></section>
      <Box sx={{ pt: 10 }}>
        <ExpWithPicLeft
          imgHeight="300"
          smallTitle="Be a green-consumer"
          title="We have a better solution"
          imgUrl="https://images.unsplash.com/photo-1510844355160-2fb07bf9af75?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
          content="WHY Biodegradable Non-Woven Fabric?<br /><br />Heslet uses 100% Rayon Fabric which is Eco-Friendly and Biodegradable.<br /><br />(Rayon breaks down nearly 100% within 60 days)<br /><br />- Check out our all purpose wipe decomposition test result"
        />
      </Box>

      {/* <Container sx={{ pb: 20 }}>
        <Grid
          container
          sx={{
            display: "flex",
            width: 1,
            border: "1px solid lightgray",
            borderRadius: "20px",
          }}
        >
          <Grid
            item
            md={6}
            sm={12}
            sx={{
              p: 2,
              pl: 3,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              width: 2 / 5,
              // border: "1px solid black",
            }}
          >
            <Box sx={{ fontSize: "20px" }}>
              <>All purpose wipe decomposition test result</>
            </Box>
            <Box sx={{ pt: 2 }}>Rayon 100% vs. Polyester(PET) Rayon 70%</Box>
          </Grid>

          <Grid
            item
            md={6}
            sm={12}
            sx={{
              p: 2,
              display: "flex",
              pl: 10,
              alginItems: "center",
              justifyContent: "space-between",
              // border: "1px solid black",
            }}
          >
            <SRLWrapper>
              <img
                src="/img/day1.jpeg"
                alt=""
                width="100"
                style={{
                  cursor: "pointer",
                  position: "relative",
                  top: "-10px",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                }}
              />
              <img
                src="/img/day2.jpeg"
                alt=""
                width="100"
                style={{
                  cursor: "pointer",
                  position: "relative",
                  top: "-10px",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                }}
              />
              <img
                src="/img/day3.jpeg"
                alt=""
                width="100"
                style={{
                  cursor: "pointer",
                  position: "relative",
                  top: "-10px",
                  paddingLeft: "10px",
                  paddingRight: "10px",
                }}
              />
              <img
                src="/img/test-result.jpeg"
                alt=""
                width="100"
                style={{
                  cursor: "pointer",
                }}
              />
            </SRLWrapper>
          </Grid>
        </Grid>
      </Container> */}
      <Box
        sx={{
          px: { md: 5, sm: 0 },

          width: 1,
          pb: 20,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box className="textTitle" sx={{ pb: 2 }}>
          Heslet's Certification & Test Report
        </Box>
        <Box
          sx={{
            backgroundColor: "white",
            minWidth: "200px",
            maxWidth: 800,
            border: "1px solid lightgray",
            p: 5,
            borderRadius: "20px",
            mt: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: { md: "row", sm: "column" },
            }}
          >
            <img src="/img/fda2.jpeg" alt="" width="200" height="60" />

            <img
              src="/img/FDA.png"
              alt=""
              width="500"
              style={{
                paddingLeft: "10px",
                cursor: "pointer",
                position: "relative",
                top: "+10px",
                left: "+10px",
              }}
            />
          </Box>
          <Box sx={{ pt: 2 }}>
            <Box sx={{ pt: 4, pb: 4 }}>Korean Material Lab Test Report</Box>
            <img src="/img/katri_all_purpose.jpeg" alt="" width="600" />
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default Wipe1;
